import {ICityParams} from "../../../../common/app/routing/charts_routes";
import {IActionContext} from "../create_path_to_action";
import {setAuthAndUser} from "./set_auth_and_user";
import {setLatestEntryAction} from "./set_latest_entry";

export const homepageAction = async (ctx: IActionContext<Omit<ICityParams, "city">>) => {
    await setAuthAndUser(ctx.store);
    await setLatestEntryAction(ctx.store);
};
